<script setup>
import { RouterView, useRoute } from 'vue-router';
import { useStateStore } from '@/stores/state.store';
import { useShopify } from './stores/shopify';
import LoadingOverlay from '@/components/UI/LoadingOverlay.vue';
import MainHeader from '@/components/MainHeader.vue';
import ProductPanel from './components/ProductPanel.vue';
import { useDataStore } from './stores/data.store';
import { useCart } from './router/cart';
import ButtonDefault from './components/atoms/ButtonDefault.vue';

const cart = useCart();
const { openCart } = cart;

const state = useStateStore();
const data = useDataStore();

const shopify = useShopify();
if (typeof shopify.cartLines == 'object') {
  shopify.cartLines = 0;
}

shopify.connect();

if (shopify.cartId != null) {
  shopify.fetchCart(shopify.cartId)
  .then((response) => {
    if (response.cart == null) {
      // Cart not found, reset
      shopify.resetCart()
    } else {
      shopify.updateCart(response.cart);
    }
  });
}

// prefecth data
data.prefetchData();

const route = useRoute();
</script>

<template>
  <loading-overlay :isLoading="state.loading" />

  <MainHeader />
  <RouterView :key="$route.path" />
  <ProductPanel />

  <div id="mobile-cart-button" class="fixed" v-if="!route.meta?.disableCart ?? true" :style="{ '--cart-offset': route.meta?.cartOffset ?? '0px' }">
    <ButtonDefault :type="route.meta?.cartType ?? 'white'" icon="Cart" class="cart__button" :badge="shopify.cartLines" @click="openCart" />
  </div>
  <div id="seeker-box" class="seeker-box">
    <div class="seeker-left"></div>
    <div class="seeker-right">
        <div id="seeker-box-title" class="seeker-title"></div>
        <div id="seeker-box-price" class="seeker-price">
          <span id="seeker-box-compare-at-price" class="compare-at-price"></span>
          <span id="seeker-box-actual-price" class="actual-price"></span>
        </div>
    </div>
  </div>

</template>

<style lang="scss">
@use '@styles/sass_variables.scss' as *;

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overscroll-behavior-y: none;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#app {
  height: 100dvh;
  width: 100vw;
  background-color: #fff;
  --header-height: 68px;

  @media screen and (min-width: $breakpoint-medium) {
    /*--header-height: 80px;*/
  }
}

.fixed {
  position: fixed;
  bottom: calc(24px + var(--cart-offset));
  right: 24px;
  z-index: 100;

  .cart__button {
    width: 62px;
    height: 62px;
    border-radius: 100px;

    @media screen and (min-width: $breakpoint-large) {
      xxdisplay: none;
    }
  }
}
</style>
